export default __webpack_public_path__ + "static/InterDisplay-LightItalic-678d0e5d80d3ea529bbd8055b78418d1.woff";